import script from "./MakerCheckerButtonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MakerCheckerButtonComponent.vue?vue&type=script&setup=true&lang=js"

import "./MakerCheckerButtonComponent.vue?vue&type=style&index=0&id=fa4c42ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa4c42ea"]])

export default __exports__